/**
 * @fileoverview POST handler for the "/engagement/create_location_set" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementCreateLocationSetCacheKeys } from "./constants";
import type { PostEngagementCreateLocationSetProps, EngagementCreateLocationSetResult } from "./types";

export const postEngagementCreateLocationSet = reactQueryMutationAdapter(
  engagementCreateLocationSetCacheKeys,
  (props: PostEngagementCreateLocationSetProps): Promise<EngagementCreateLocationSetResult> => {
    return fetch("/engagement/create_location_set", "POST", props);
  }
);
